import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { getDeviceInfo } from '../../utils/device';
import { getBlockOrder } from '../../utils/gsap';


function removeActiveImages(blockId, currentId) {
	// console.log('removeActiveImages', blockId, currentId);
	const stickyBlockWrapper = document.querySelector('#'+blockId);
	const stickyBlockImages = stickyBlockWrapper.querySelectorAll('.sticky-block__image');
	stickyBlockImages.forEach((stickyBlock) => {
		stickyBlock.classList.remove('active');
	});
}

export function initStickyBlock () {
	const stickyBlockWrapper = document.querySelectorAll('.sticky-block-wrapper');
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!stickyBlockWrapper.length) return;

	function removeStayActive(blockId, currentBlock) {
		// console.log('removeStayActive');
		const stickyBlockWrapper = document.querySelector('#'+blockId);

		const stickyBlocks = stickyBlockWrapper.querySelectorAll('.sticky-block__content');
		stickyBlocks.forEach((stickyBlock) => {

			const id = stickyBlock.dataset.itemId;

			if(stickyBlock.dataset.itemId != currentBlock) {
				stickyBlock.classList.remove('active');
			}
			if(id < currentBlock) {
				stickyBlock.classList.add('up');
			}
			if(id > currentBlock) {
				stickyBlock.classList.remove('up');
			}
		});
	}

	function updateArrowVisibility(currentBlock, counter, prev, next) {
		if(currentBlock == 1) {
			// console.log("currentBlock === 1");
			prev.classList.add('invisible','pointer-events-none');
		} else {
			prev.classList.remove('invisible','pointer-events-none');
		}
		if(currentBlock === counter.children.length) {
			next.classList.add('invisible','pointer-events-none');
		} else {
			next.classList.remove('invisible','pointer-events-none');
		}
	}

	function updateCounter(currentBlock, counter, prev, next) {
		const space = 42;
		const to = (currentBlock - 1) * space;
    const duration = isReduceMotion ? 0 : .5;
		gsap.to(counter, {y: -to, duration: duration});

		// console.log('updateCounter', currentBlock, counter.children.length);

		updateArrowVisibility(currentBlock, counter, prev, next);
	}

	stickyBlockWrapper.forEach((wrapper) => {
		const blockId = wrapper.id;
		const stickyBlocks = wrapper.querySelectorAll('.sticky-block:not(:first-child)');;
		const counter = wrapper.querySelector('.sticky-block__counter');
		const prev = wrapper.querySelector('.sticky-block__prev');
		const next = wrapper.querySelector('.sticky-block__next');

		let currentBlock = 1;

		prev.addEventListener('click', () => {
			// console.log('prev');
			if(currentBlock > 1) {
				const block = wrapper.querySelector('.sticky-block[data-item-id="'+(currentBlock-1)+'"]');
				const elementPosition = block.getBoundingClientRect().top;
    			const offsetPosition = elementPosition - window.innerHeight + 100;

				window.scrollBy({
					top: offsetPosition,
					behavior: "smooth"
			   	});
				currentBlock--;
			}
		});
		next.addEventListener('click', () => {
			if(currentBlock <= stickyBlocks.length) {

				const block = wrapper.querySelector('.sticky-block[data-item-id="'+(parseInt(currentBlock)+1)+'"]');
				const elementPosition = block.getBoundingClientRect().top;
    		const offsetPosition = elementPosition - 170;

				window.scrollBy({
					top: offsetPosition,
					behavior: "smooth"
			   	});
				currentBlock++;
			}
		});

		stickyBlocks.forEach((stickyBlock, index) => {
			const refreshPriorityOrder = getBlockOrder(stickyBlock);
			ScrollTrigger.create({
				trigger: stickyBlock,
				start: "center top+=60%",
				pin: true,
				refreshPriority: refreshPriorityOrder,
				markers: false,
				onLeaveBack: (self) =>  {

					if(index === 0) {

						const id = 1;
						const content = wrapper.querySelector('.sticky-block__content[data-item-id="'+id+'"]');
						const image = wrapper.querySelector('.sticky-block__image[data-item-id="'+id+'"]');

						currentBlock = parseInt(id);
						removeStayActive(blockId, currentBlock);
						removeActiveImages(blockId, currentBlock);
						content.classList.add('active');
						content.classList.remove('up');
						image.classList.add('active');

						updateCounter(currentBlock, counter, prev, next);
					}

				},
				onToggle: (self) => {

					if (self.isActive) {
						const id = parseInt(self.trigger.dataset.itemId);
						const content = wrapper.querySelector('.sticky-block__content[data-item-id="'+id+'"]');
						const image = wrapper.querySelector('.sticky-block__image[data-item-id="'+id+'"]');

						currentBlock = parseInt(id);
						removeStayActive(blockId, currentBlock);
						removeActiveImages(blockId, currentBlock);
						content.classList.add('active');
						content.classList.remove('up');
						image.classList.add('active');

						updateCounter(currentBlock, counter, prev, next);
					}

				},

				onUpdate: (self) => {
				//   console.log(
				// 	"progress:",
				// 	self.progress.toFixed(3),
				// 	"direction:",
				// 	self.direction,
				// 	"velocity",
				// 	self.getVelocity()
				//   );
				},
			  });
		});
		updateArrowVisibility(currentBlock, counter, prev, next);
	});
}

